import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import reportsService from "./reportsService";
import { UserId } from "../../models/userId.model";

interface User {
  // Define the properties of a user
}

export const investorReports = createAsyncThunk(
  "admin/rm/reports",
  async (data: any, thunkAPI) => {
    try {
       const response = await reportsService.investorReports(data);
       return response;
    } catch (error: any) {
      return thunkAPI.rejectWithValue(error.response.data);
    }
  }
);


export const investmentReports = createAsyncThunk(
  "admin/rm/investment-reports",
  async (data: any, thunkAPI) => {
    try {
       const response = await reportsService.investmentReports(data);
       return response;
    } catch (error: any) {
      return thunkAPI.rejectWithValue(error.response.data);
    }
  }
);

const initialState = {
  users: [] as User[],
  data: {},
  details:{},
  totalPages: 0,
  pageIndex: 1,
  isError: false,
  isSuccess: false,
  isLoading: false,
  isDownloading: false, // New state to manage download operation
  message: "",
};


export const reportsSlice = createSlice({
  name: "users",
  initialState,
  reducers: {
    resetState: (state) => initialState,
  },
  
  extraReducers: (builder) => {
    builder
      .addCase(investorReports.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(investorReports.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isError = false;
        state.isSuccess = true;
        state.data = action.payload; // Extract users from fdList
        // state.totalPages = action.payload?.totalPages;
        // state.pageIndex = action.payload?.pageIndex;
      })
      .addCase(investorReports.rejected, (state, action) => {
        state.isError = true;
        state.isLoading = false;
        state.isSuccess = false;
        state.message = action.error.message || "";
      })
      .addCase(investmentReports.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(investmentReports.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isError = false;
        state.isSuccess = true;
        state.data = action.payload;
      })
      .addCase(investmentReports.rejected, (state, action) => {
        state.isError = true;
        state.isLoading = false;
        state.isSuccess = false;
        state.message = action.error.message || "";
      });
    }
});

export const { resetState } = reportsSlice.actions;
export default reportsSlice.reducer;
